// extracted by css-extract-rspack-plugin
export default {"buttonContainer":"H00si","button":"b6kjq","message":"QWGWT"};